/**
 * @generated SignedSource<<16815d81f96314662d77588bdfa4dd64>>
 * @relayHash 610769ddba0745c29c1d091e4de20e44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d264a3dd389a8f220bf4839e44ce968d377851a3e33b5d0d4143f5647e7233d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSalesforceAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchSalesforceAttributeFilterSource = "CUSTOM_PROPERTIES_DATE" | "CUSTOM_PROPERTIES_KEYWORD" | "CUSTOM_PROPERTIES_NUMBER" | "RELATIONSHIPS" | "%future added value";
export type SearchServiceNowAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchServiceNowAttributeFilterSource = "ADD_ON_PROPERTIES_DATE" | "KEYWORD" | "RELATIONSHIPS" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  gongFilters?: SearchGongFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  serviceNowFilters?: SearchServiceNowFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchGongFilters = {
  crmAccountName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  attributeFilters?: ReadonlyArray<SearchSalesforceAttributeFilter> | null;
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  isClosed?: boolean | null;
  knowledgeArticlePublishStatuses?: ReadonlyArray<string> | null;
  leadStatuses?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
  taskStatuses?: ReadonlyArray<string> | null;
  taskTypes?: ReadonlyArray<string> | null;
};
export type SearchSalesforceAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchSalesforceAttributeFilterOperator;
  source: SearchSalesforceAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchServiceNowFilters = {
  attributeFilters?: ReadonlyArray<SearchServiceNowAttributeFilter> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchServiceNowAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchServiceNowAttributeFilterOperator;
  source: SearchServiceNowAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchSortInput = {
  field: string;
  key?: string | null;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null> | null;
  layerId?: string | null;
  name?: string | null;
  shadowId?: string | null;
};
export type SearchLayerDefinition = {
  abTestId?: string | null;
  armId?: string | null;
  connectorSources?: ReadonlyArray<string | null> | null;
  entity?: string | null;
  integrationARI?: string | null;
  layerId?: string | null;
  providerId?: string | null;
  shadowId?: string | null;
  statsigLayerId?: string | null;
  subEntity?: string | null;
};
export type SearchMatchingLayerExperimentsMetadata = {
  matchingLayers?: ReadonlyArray<SearchMatchingLayer | null> | null;
};
export type SearchMatchingLayer = {
  layerName?: string | null;
  layerType?: string | null;
};
export type searchResultsAsyncQuery$variables = {
  after?: string | null;
  assetsFilters?: SearchAssetsFilter | null;
  cloudIdARIs: ReadonlyArray<string>;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  disableQueryReplacement?: boolean | null;
  enableHighlighting?: boolean | null;
  enableRelevanceDebugging?: boolean | null;
  entities: ReadonlyArray<string>;
  expectResult?: boolean | null;
  experience: string;
  experimentId?: string | null;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null> | null;
  fanoutExperimentCohort?: string | null;
  includeCaseEmbeddedComments?: boolean | null;
  includeFastJiraHydration?: boolean | null;
  includeGithubCode?: boolean | null;
  includeJiraLiteModeFields?: boolean | null;
  includeNavBoostScore?: boolean | null;
  includePassionfruitAsk?: boolean | null;
  includePositions?: boolean | null;
  includeReactionsAndCommentCount?: boolean | null;
  includeRisk?: boolean | null;
  includeThirdPartyId?: boolean | null;
  jiraFilters?: SearchJiraFilter | null;
  limit: number;
  matchingLayerExperimentsMetadata?: SearchMatchingLayerExperimentsMetadata | null;
  mercuryFilters?: SearchMercuryFilter | null;
  query: string;
  queryVersion?: number | null;
  searchSessionId?: string | null;
  sessionId?: string | null;
  shadowExperimentId?: string | null;
  sort?: ReadonlyArray<SearchSortInput | null> | null;
  sourceProduct?: string | null;
  talentFilters?: SearchTalentFilter | null;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  useCaseId?: string | null;
};
export type searchResultsAsyncQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData">;
};
export type searchResultsAsyncQuery = {
  response: searchResultsAsyncQuery$data;
  variables: searchResultsAsyncQuery$variables;
};
({
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
  "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
  "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
  "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
  "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleadnounenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleaduserastitleenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isprojectrendererenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslacktopreactionenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslackworkspacemetadataenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import isLeadNounEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-noun-enabled.relayprovider';
import isLeadUserAsTitleEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-user-as-title-enabled.relayprovider';
import includeSlackWorkspaceMetadata_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/../is-slack-workspace-metadata-enabled.relayprovider';
import includeSlackTopReaction_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/is-slack-top-reaction-enabled.relayprovider';
import isProjectRendererEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-project/is-project-renderer-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARIs"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableRelevanceDebugging"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expectResult"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCaseEmbeddedComments"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFastJiraHydration"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeGithubCode"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraLiteModeFields"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePassionfruitAsk"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactionsAndCommentCount"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRisk"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchingLayerExperimentsMetadata"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCaseId"
},
v40 = {
  "kind": "Variable",
  "name": "useCaseId",
  "variableName": "useCaseId"
},
v41 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "enableRelevanceDebugging",
    "variableName": "enableRelevanceDebugging"
  },
  {
    "kind": "Variable",
    "name": "expectResult",
    "variableName": "expectResult"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "cloudIdARIs"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "matchingLayerExperimentsMetadata",
    "variableName": "matchingLayerExperimentsMetadata"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  (v40/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v43 = {
  "kind": "ScalarField",
  "name": "id"
},
v44 = {
  "kind": "ScalarField",
  "name": "description"
},
v45 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v46 = {
  "kind": "ScalarField",
  "name": "title"
},
v47 = {
  "kind": "ScalarField",
  "name": "url"
},
v48 = {
  "kind": "ScalarField",
  "name": "type"
},
v49 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v50 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v51 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v52 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v53 = {
  "kind": "ScalarField",
  "name": "value"
},
v54 = {
  "kind": "ScalarField",
  "name": "label"
},
v55 = [
  (v54/*: any*/)
],
v56 = {
  "kind": "ScalarField",
  "name": "key"
},
v57 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v58 = {
  "kind": "ScalarField",
  "name": "name"
},
v59 = [
  (v58/*: any*/)
],
v60 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v61 = {
  "kind": "ScalarField",
  "name": "total"
},
v62 = {
  "kind": "ScalarField",
  "name": "count"
},
v63 = [
  (v43/*: any*/)
],
v64 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v65 = {
  "kind": "ScalarField",
  "name": "picture"
},
v66 = {
  "kind": "ScalarField",
  "name": "email"
},
v67 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v68 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v58/*: any*/),
        (v65/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v66/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v67/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v43/*: any*/)
      ]
    }
  ]
},
v69 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v59/*: any*/),
      "type": "ExternalRepository"
    },
    (v64/*: any*/)
  ]
},
v70 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v71 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v70/*: any*/),
        (v47/*: any*/),
        (v50/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v64/*: any*/)
  ]
},
v72 = [
  {
    "kind": "ScalarField",
    "name": "reactionType"
  },
  (v61/*: any*/)
],
v73 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v74 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v67/*: any*/)
},
v75 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        (v66/*: any*/),
        (v65/*: any*/),
        (v73/*: any*/),
        (v74/*: any*/),
        (v43/*: any*/)
      ]
    }
  ]
},
v76 = [
  (v42/*: any*/),
  (v58/*: any*/),
  (v65/*: any*/),
  (v43/*: any*/)
],
v77 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v76/*: any*/)
},
v78 = {
  "kind": "ScalarField",
  "name": "status"
},
v79 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v80 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v42/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v73/*: any*/),
                    (v58/*: any*/),
                    (v79/*: any*/),
                    (v66/*: any*/),
                    (v65/*: any*/),
                    (v74/*: any*/),
                    (v43/*: any*/)
                  ],
                  "type": "ThirdPartyUser"
                },
                (v64/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v70/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v43/*: any*/)
          ]
        }
      ]
    }
  ]
},
v81 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v82 = [
  (v43/*: any*/),
  (v58/*: any*/),
  (v66/*: any*/),
  (v65/*: any*/),
  (v73/*: any*/),
  (v74/*: any*/)
],
v83 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v82/*: any*/)
    },
    {
      "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
      "kind": "LinkedField",
      "name": "linkedUsers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v42/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v58/*: any*/),
                    (v65/*: any*/),
                    (v43/*: any*/)
                  ],
                  "type": "AtlassianAccountUser"
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v63/*: any*/),
                  "type": "AppUser"
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v63/*: any*/),
                  "type": "CustomerUser"
                }
              ]
            },
            (v43/*: any*/)
          ]
        }
      ]
    }
  ]
},
v84 = [
  (v43/*: any*/),
  (v58/*: any*/)
],
v85 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v84/*: any*/)
},
v86 = [
  (v85/*: any*/)
],
v87 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v86/*: any*/)
},
v88 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v89 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v90 = [
  (v58/*: any*/),
  (v43/*: any*/)
],
v91 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v90/*: any*/)
},
v92 = [
  (v91/*: any*/)
],
v93 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": (v92/*: any*/)
},
v94 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v92/*: any*/)
},
v95 = [
  (v42/*: any*/),
  (v58/*: any*/),
  (v43/*: any*/)
],
v96 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v95/*: any*/)
},
v97 = [
  (v42/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v43/*: any*/),
      (v70/*: any*/)
    ],
    "type": "ExternalCustomerOrg"
  },
  (v64/*: any*/)
],
v98 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v97/*: any*/)
},
v99 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v100 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v86/*: any*/)
},
v101 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v86/*: any*/)
},
v102 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v103 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v104 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v105 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v106 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v107 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v108 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v58/*: any*/),
    (v79/*: any*/),
    (v66/*: any*/),
    (v65/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v43/*: any*/)
  ]
},
v109 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v84/*: any*/)
},
v110 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v111 = [
  (v57/*: any*/),
  (v58/*: any*/),
  (v43/*: any*/)
],
v112 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v113 = [
  {
    "concreteType": "JiraLabelEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraLabel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v59/*: any*/)
      }
    ]
  }
],
v114 = [
  (v49/*: any*/),
  (v57/*: any*/)
],
v115 = [
  (v56/*: any*/),
  (v70/*: any*/),
  (v43/*: any*/)
],
v116 = [
  {
    "kind": "ScalarField",
    "name": "targetDate"
  },
  {
    "kind": "ScalarField",
    "name": "targetDateType"
  }
],
v117 = [
  (v49/*: any*/)
],
v118 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v119 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": [
    (v58/*: any*/),
    (v70/*: any*/),
    (v43/*: any*/)
  ]
},
v120 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v121 = [
  (v56/*: any*/),
  (v43/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeCaseEmbeddedComments",
            "variableName": "includeCaseEmbeddedComments"
          },
          {
            "kind": "Variable",
            "name": "includeFastJiraHydration",
            "variableName": "includeFastJiraHydration"
          },
          {
            "kind": "Variable",
            "name": "includeGithubCode",
            "variableName": "includeGithubCode"
          },
          {
            "kind": "Variable",
            "name": "includeJiraLiteModeFields",
            "variableName": "includeJiraLiteModeFields"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includePassionfruitAsk",
            "variableName": "includePassionfruitAsk"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeReactionsAndCommentCount",
            "variableName": "includeReactionsAndCommentCount"
          },
          {
            "kind": "Variable",
            "name": "includeRisk",
            "variableName": "includeRisk"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          },
          (v40/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v29/*: any*/),
      (v2/*: any*/),
      (v37/*: any*/),
      (v26/*: any*/),
      (v9/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v25/*: any*/),
      (v1/*: any*/),
      (v28/*: any*/),
      (v36/*: any*/),
      (v4/*: any*/),
      (v38/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v12/*: any*/),
      (v33/*: any*/),
      (v13/*: any*/),
      (v27/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v11/*: any*/),
      (v39/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/),
      (v10/*: any*/),
      (v21/*: any*/),
      (v24/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v23/*: any*/),
      (v18/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v22/*: any*/),
      (v15/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleadnounenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleaduserastitleenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "search",
            "args": (v41/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "asyncSearch",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isCachedResult"
              },
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      {
                        "concreteType": "SearchLinkedResult",
                        "kind": "LinkedField",
                        "name": "linkedResults",
                        "plural": true,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          },
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v44/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/)
                        ]
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSearchResult"
                      },
                      (v46/*: any*/),
                      (v48/*: any*/),
                      (v47/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareLocalizationField",
                                    "kind": "LinkedField",
                                    "name": "localizedLabel",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "messageId"
                                      }
                                    ]
                                  },
                                  (v53/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v55/*: any*/)
                              },
                              (v43/*: any*/),
                              (v56/*: any*/),
                              (v44/*: any*/)
                            ]
                          },
                          (v57/*: any*/)
                        ],
                        "type": "SearchResultAtlasGoal"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "dueDate",
                                "plural": false,
                                "selections": (v55/*: any*/)
                              },
                              {
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/),
                                  (v53/*: any*/)
                                ]
                              },
                              (v43/*: any*/),
                              (v56/*: any*/)
                            ]
                          },
                          (v57/*: any*/)
                        ],
                        "type": "SearchResultAtlasProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "SearchFederatedEmailUser",
                                    "kind": "LinkedField",
                                    "name": "sender",
                                    "plural": false,
                                    "selections": (v59/*: any*/)
                                  }
                                ],
                                "type": "SearchFederatedEmailEntity"
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultFederated"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "tier"
                          },
                          {
                            "concreteType": "CompassComponent",
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              (v43/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "ownerId"
                          }
                        ],
                        "type": "SearchResultCompassComponent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v60/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          },
                          (v57/*: any*/),
                          {
                            "concreteType": "SearchConfluenceResultSpace",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                              (v43/*: any*/),
                              (v58/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUiLink"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "confluenceEntity",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/),
                                  {
                                    "concreteType": "ConfluenceCommentCountSummary",
                                    "kind": "LinkedField",
                                    "name": "commentCountSummary",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ConfluenceLikesSummary",
                                    "kind": "LinkedField",
                                    "name": "likesSummary",
                                    "plural": false,
                                    "selections": [
                                      (v62/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              (v64/*: any*/)
                            ]
                          },
                          (v68/*: any*/),
                          {
                            "condition": "includeNavBoostScore",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "navBoostScore"
                              }
                            ]
                          }
                        ],
                        "type": "SearchConfluencePageBlogAttachment"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v57/*: any*/),
                          (v60/*: any*/)
                        ],
                        "type": "SearchConfluenceSpace"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v52/*: any*/),
                          (v45/*: any*/),
                          (v51/*: any*/),
                          (v50/*: any*/),
                          (v49/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "permissionLevel"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v58/*: any*/),
                                  (v69/*: any*/)
                                ],
                                "type": "ExternalBranch"
                              },
                              (v64/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v71/*: any*/),
                                  {
                                    "condition": "includeReactionsAndCommentCount",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "ExternalReaction",
                                        "kind": "LinkedField",
                                        "name": "reactionsV2",
                                        "plural": true,
                                        "selections": (v72/*: any*/)
                                      }
                                    ]
                                  },
                                  (v75/*: any*/)
                                ],
                                "type": "ExternalComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/)
                                    ]
                                  },
                                  (v69/*: any*/)
                                ],
                                "type": "ExternalCommit"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v70/*: any*/),
                                          (v47/*: any*/)
                                        ],
                                        "type": "ExternalSpace"
                                      },
                                      (v64/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalReaction",
                                    "kind": "LinkedField",
                                    "name": "reactions",
                                    "plural": true,
                                    "selections": (v72/*: any*/)
                                  },
                                  (v78/*: any*/),
                                  {
                                    "concreteType": "ExternalDocumentType",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": [
                                      (v57/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalLargeContent",
                                    "kind": "LinkedField",
                                    "name": "nonIndexableContent",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "mediaThumbnailUrl"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v70/*: any*/)
                                        ],
                                        "type": "ExternalDocument"
                                      },
                                      (v64/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "includeThirdPartyId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "includeReactionsAndCommentCount",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "commentCount"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v73/*: any*/),
                                  (v80/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "concreteType": "ExternalAttachment",
                                    "kind": "LinkedField",
                                    "name": "attachments",
                                    "plural": true,
                                    "selections": [
                                      (v46/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                      },
                                      (v47/*: any*/),
                                      (v81/*: any*/),
                                      (v42/*: any*/)
                                    ]
                                  },
                                  (v83/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v70/*: any*/),
                                          (v87/*: any*/),
                                          (v48/*: any*/),
                                          (v43/*: any*/),
                                          (v88/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "membershipType"
                                          }
                                        ],
                                        "type": "ExternalConversation"
                                      },
                                      (v64/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastActive"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "reactionCount"
                                  }
                                ],
                                "type": "ExternalMessage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  (v70/*: any*/),
                                  (v88/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": true,
                                    "selections": [
                                      (v42/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalConversation"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v78/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                  },
                                  (v89/*: any*/),
                                  (v93/*: any*/),
                                  (v94/*: any*/)
                                ],
                                "type": "ExternalCampaign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "displayNumber"
                                  },
                                  (v78/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "closedAt"
                                  },
                                  (v89/*: any*/),
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "owners",
                                    "plural": true,
                                    "selections": [
                                      (v91/*: any*/),
                                      (v96/*: any*/)
                                    ]
                                  },
                                  (v94/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": (v97/*: any*/)
                                  }
                                ],
                                "type": "ExternalCase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v70/*: any*/),
                                  (v93/*: any*/),
                                  (v98/*: any*/),
                                  {
                                    "concreteType": "ExternalCustomerOrgLastActivity",
                                    "kind": "LinkedField",
                                    "name": "customerOrgLastActivity",
                                    "plural": false,
                                    "selections": (v99/*: any*/)
                                  }
                                ],
                                "type": "ExternalCustomerOrg"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "stage"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dealClosedAt"
                                  },
                                  {
                                    "concreteType": "ExternalDealLastActivity",
                                    "kind": "LinkedField",
                                    "name": "lastActivity",
                                    "plural": false,
                                    "selections": (v99/*: any*/)
                                  },
                                  (v93/*: any*/),
                                  (v98/*: any*/)
                                ],
                                "type": "ExternalDeal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v71/*: any*/),
                                  (v100/*: any*/),
                                  (v101/*: any*/),
                                  (v102/*: any*/),
                                  (v56/*: any*/),
                                  (v78/*: any*/)
                                ],
                                "type": "ExternalProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v71/*: any*/),
                                  (v100/*: any*/),
                                  (v101/*: any*/),
                                  (v102/*: any*/),
                                  (v78/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "team"
                                  },
                                  {
                                    "concreteType": "ExternalWorkItemProject",
                                    "kind": "LinkedField",
                                    "name": "workItemProject",
                                    "plural": false,
                                    "selections": (v84/*: any*/)
                                  },
                                  {
                                    "concreteType": "ExternalProvider",
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": (v59/*: any*/)
                                  }
                                ],
                                "type": "ExternalWorkItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v46/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastUpdate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "pullRequestId"
                                  },
                                  {
                                    "alias": "pullRequestStatus",
                                    "kind": "ScalarField",
                                    "name": "status"
                                  },
                                  (v69/*: any*/)
                                ],
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "durationInSeconds"
                                  },
                                  (v81/*: any*/),
                                  {
                                    "concreteType": "ExternalChapter",
                                    "kind": "LinkedField",
                                    "name": "chapters",
                                    "plural": true,
                                    "selections": [
                                      (v46/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                      (v85/*: any*/),
                                      (v96/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ExternalVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v43/*: any*/),
                                  (v47/*: any*/),
                                  (v103/*: any*/),
                                  (v93/*: any*/)
                                ],
                                "type": "ExternalDashboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v43/*: any*/),
                                  (v47/*: any*/),
                                  {
                                    "alias": "dataTableType",
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v103/*: any*/),
                                  (v93/*: any*/)
                                ],
                                "type": "ExternalDataTable"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountName"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "contactUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                          (v58/*: any*/),
                                          (v74/*: any*/),
                                          (v43/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalCustomerContact"
                              }
                            ]
                          },
                          (v104/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v101/*: any*/),
                                  (v105/*: any*/),
                                  (v106/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "recurringEventId"
                                  },
                                  (v107/*: any*/)
                                ],
                                "type": "ExternalCalendarEvent"
                              },
                              (v64/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ExternalThumbnail",
                                    "kind": "LinkedField",
                                    "name": "thumbnail",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                      }
                                    ]
                                  }
                                ],
                                "type": "ExternalDesign"
                              }
                            ]
                          },
                          {
                            "concreteType": "SearchResultGraphDocument",
                            "kind": "LinkedField",
                            "name": "linkedEntities",
                            "plural": true,
                            "selections": [
                              (v43/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v106/*: any*/),
                                      (v105/*: any*/),
                                      (v107/*: any*/)
                                    ],
                                    "type": "ExternalCalendarEvent"
                                  },
                                  (v64/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v70/*: any*/),
                                      (v75/*: any*/)
                                    ],
                                    "type": "ExternalComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v83/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v87/*: any*/),
                                              (v48/*: any*/)
                                            ],
                                            "type": "ExternalConversation"
                                          },
                                          (v64/*: any*/)
                                        ]
                                      },
                                      (v73/*: any*/),
                                      (v80/*: any*/),
                                      (v44/*: any*/)
                                    ],
                                    "type": "ExternalMessage"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v44/*: any*/)
                                    ],
                                    "type": "ExternalConversation"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "parentId"
                              },
                              (v104/*: any*/),
                              {
                                "concreteType": "ThirdPartyUser",
                                "kind": "LinkedField",
                                "name": "initialContributors",
                                "plural": true,
                                "selections": (v82/*: any*/)
                              },
                              (v51/*: any*/),
                              (v108/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "ThirdPartyUser",
                            "kind": "LinkedField",
                            "name": "initialContributors",
                            "plural": true,
                            "selections": [
                              (v58/*: any*/),
                              (v65/*: any*/),
                              (v43/*: any*/),
                              (v66/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "SearchResultGraphTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "tabId"
                              },
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v42/*: any*/)
                            ]
                          },
                          (v103/*: any*/),
                          {
                            "concreteType": "SearchResultGraphAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                              (v46/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "fileType"
                              },
                              (v47/*: any*/),
                              (v42/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "containerName"
                          },
                          {
                            "concreteType": "ThirdPartyUser",
                            "kind": "LinkedField",
                            "name": "allContributors",
                            "plural": true,
                            "selections": (v84/*: any*/)
                          },
                          (v108/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "links"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "linkedEntitiesType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "connectorId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "connectorProduct"
                          },
                          {
                            "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isSharedChannel"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__isleadnounenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v78/*: any*/),
                                      (v89/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__isleaduserastitleenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "ExternalUser",
                                            "kind": "LinkedField",
                                            "name": "leadUser",
                                            "plural": false,
                                            "selections": (v92/*: any*/)
                                          }
                                        ]
                                      },
                                      (v93/*: any*/),
                                      (v94/*: any*/)
                                    ],
                                    "type": "ExternalLead"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "SearchSlackReaction",
                                "kind": "LinkedField",
                                "name": "topReaction",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "emojiName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "emojiUrl"
                                  },
                                  (v62/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultGraphDocument"
                      },
                      {
                        "condition": "includeGithubCode",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "path"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "language"
                              },
                              (v49/*: any*/),
                              {
                                "concreteType": "SearchResultCodeRepository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v58/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "namespace"
                                  },
                                  (v47/*: any*/),
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultGraphCode"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/),
                          (v57/*: any*/),
                          {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                              {
                                "condition": "includeFastJiraHydration",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueTypeAvatarUrl"
                                  },
                                  {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": (v90/*: any*/)
                                      },
                                      (v43/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                          "project"
                                        ]
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v42/*: any*/),
                                              (v58/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v109/*: any*/)
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              (v43/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                  },
                                  {
                                    "concreteType": "JiraSingleSelectUserPickerField",
                                    "kind": "LinkedField",
                                    "name": "assigneeField",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v43/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v110/*: any*/),
                              (v56/*: any*/),
                              {
                                "condition": "includeFastJiraHydration",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v58/*: any*/),
                                      {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "medium"
                                          }
                                        ]
                                      },
                                      (v43/*: any*/)
                                    ]
                                  },
                                  (v109/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": (v76/*: any*/)
                                  },
                                  {
                                    "condition": "includeJiraLiteModeFields",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "alias": "fastPriority",
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": (v111/*: any*/)
                                      },
                                      {
                                        "alias": "fastLabels",
                                        "args": (v112/*: any*/),
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "labels",
                                        "plural": false,
                                        "selections": (v113/*: any*/),
                                        "storageKey": "labels(first:5)"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "condition": "includeJiraLiteModeFields",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "condition": "includeFastJiraHydration",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriorityField",
                                        "kind": "LinkedField",
                                        "name": "priorityField",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": (v111/*: any*/)
                                          },
                                          (v43/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraLabelsField",
                                        "kind": "LinkedField",
                                        "name": "labelsField",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "args": (v112/*: any*/),
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": (v113/*: any*/),
                                            "storageKey": "selectedLabelsConnection(first:5)"
                                          },
                                          (v43/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "projectKey"
                          },
                          (v49/*: any*/),
                          (v57/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v110/*: any*/),
                              {
                                "condition": "includeJiraLiteModeFields",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "lead",
                                    "plural": false,
                                    "selections": (v76/*: any*/)
                                  },
                                  {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "small"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                  },
                                  {
                                    "concreteType": "JiraProjectCategory",
                                    "kind": "LinkedField",
                                    "name": "category",
                                    "plural": false,
                                    "selections": (v90/*: any*/)
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ]
                          },
                          (v68/*: any*/)
                        ],
                        "type": "SearchResultJiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "SearchResultJiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/),
                          (v57/*: any*/),
                          {
                            "concreteType": "JiraBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                              (v57/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "boardFrontendUrl"
                              },
                              (v43/*: any*/)
                            ]
                          }
                        ],
                        "type": "SearchResultJiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "SearchResultJiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v114/*: any*/),
                        "type": "SearchResultJiraFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v115/*: any*/)
                              },
                              {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                  (v56/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "color"
                                  },
                                  (v70/*: any*/),
                                  (v43/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v116/*: any*/)
                              },
                              (v43/*: any*/),
                              (v58/*: any*/),
                              {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": (v84/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": (v95/*: any*/)
                              }
                            ]
                          },
                          (v49/*: any*/)
                        ],
                        "type": "SearchResultMercuryFocusArea"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v49/*: any*/),
                          {
                            "concreteType": "MercuryFocusArea",
                            "kind": "LinkedField",
                            "name": "focusArea",
                            "plural": false,
                            "selections": (v90/*: any*/)
                          }
                        ],
                        "type": "SearchResultMercuryFocusAreaStatusUpdate"
                      },
                      {
                        "condition": "includeRisk",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/),
                              {
                                "concreteType": "MercuryRisk",
                                "kind": "LinkedField",
                                "name": "risk",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MercuryRiskStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": (v115/*: any*/)
                                  },
                                  {
                                    "concreteType": "MercuryRiskTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": (v116/*: any*/)
                                  },
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultMercuryRisk"
                          }
                        ]
                      },
                      {
                        "condition": "includePassionfruitAsk",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "SpfAsk",
                                "kind": "LinkedField",
                                "name": "ask",
                                "plural": false,
                                "selections": [
                                  (v78/*: any*/),
                                  {
                                    "concreteType": "SpfAskTargetDate",
                                    "kind": "LinkedField",
                                    "name": "targetDate",
                                    "plural": false,
                                    "selections": (v116/*: any*/)
                                  },
                                  (v43/*: any*/)
                                ]
                              },
                              (v49/*: any*/)
                            ],
                            "type": "SearchResultSpfAsk"
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v117/*: any*/),
                        "type": "SearchResultTrelloBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v117/*: any*/),
                        "type": "SearchResultTrelloCard"
                      },
                      {
                        "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/),
                              {
                                "concreteType": "AssetsSchema",
                                "kind": "LinkedField",
                                "name": "objectSchemaEntity",
                                "plural": false,
                                "selections": [
                                  (v58/*: any*/),
                                  (v70/*: any*/),
                                  (v118/*: any*/),
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectSchema"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/),
                              (v119/*: any*/),
                              {
                                "concreteType": "AssetsObjectType",
                                "kind": "LinkedField",
                                "name": "objectTypeEntity",
                                "plural": false,
                                "selections": [
                                  (v58/*: any*/),
                                  (v70/*: any*/),
                                  {
                                    "concreteType": "AssetsIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": (v120/*: any*/)
                                  },
                                  (v118/*: any*/),
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObjectType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v49/*: any*/),
                              (v119/*: any*/),
                              {
                                "concreteType": "AssetsObject",
                                "kind": "LinkedField",
                                "name": "objectEntity",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AssetsAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": (v120/*: any*/)
                                  },
                                  (v118/*: any*/),
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultAssetsObject"
                          }
                        ]
                      },
                      {
                        "condition": "includePositions",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "RadarPosition",
                                "kind": "LinkedField",
                                "name": "position",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  {
                                    "concreteType": "RadarWorker",
                                    "kind": "LinkedField",
                                    "name": "worker",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          (v65/*: any*/),
                                          (v43/*: any*/)
                                        ]
                                      },
                                      (v43/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                          "positionId",
                                          "positionStatus",
                                          "positionJobTitle",
                                          "positionPositionTitle",
                                          "positionKey",
                                          "positionExternalPositionKey",
                                          "positionWorker",
                                          "focusArea"
                                        ]
                                      }
                                    ],
                                    "concreteType": "RadarFieldValueIdPair",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                          (v42/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "stringValue",
                                                "kind": "ScalarField",
                                                "name": "value"
                                              }
                                            ],
                                            "type": "RadarStringFieldValue"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": false,
                                                "selections": [
                                                  (v42/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v58/*: any*/),
                                                      {
                                                        "concreteType": "MercuryFocusAreaStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": (v121/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "MercuryFocusAreaHealth",
                                                        "kind": "LinkedField",
                                                        "name": "health",
                                                        "plural": false,
                                                        "selections": (v121/*: any*/)
                                                      }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                  },
                                                  (v64/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "RadarAriFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                  },
                                  (v43/*: any*/)
                                ]
                              }
                            ],
                            "type": "SearchResultTalentPosition"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "traceId"
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              }
            ]
          },
          {
            "alias": "search",
            "args": (v41/*: any*/),
            "filters": [
              "experience",
              "useCaseId",
              "enableHighlighting",
              "enableRelevanceDebugging",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "expectResult",
              "filters",
              "analytics",
              "experimentContext",
              "matchingLayerExperimentsMetadata"
            ],
            "handle": "connection",
            "key": "SearchResultsAsyncPagination__search",
            "kind": "LinkedHandle",
            "name": "asyncSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6d264a3dd389a8f220bf4839e44ce968d377851a3e33b5d0d4143f5647e7233d",
    "metadata": {},
    "name": "searchResultsAsyncQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
      "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
      "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
      "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
      "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider
    }
  }
};
})();

(node as any).hash = "6645462eca8b95cb0bccdd3d89dfda1f";

export default node;
